import { type FC } from 'react';
import { Actions } from '../actions';
import { DetailToolbarHeader, type Props as HeaderProps } from '../detail-toolbar-header';
import * as Styled from './styled';

type Props = HeaderProps & {
  content?: React.ReactNode;
  actions: React.ReactNode;
};

export const DetailToolbar: FC<Props> = ({
  title,
  onClose,
  isLoading = false,
  content,
  actions,
}) => (
  <Styled.Wrapper>
    <DetailToolbarHeader title={title} onClose={onClose} isLoading={isLoading} />
    {!isLoading && (
      <>
        {content ?? null}
        <Actions>{actions}</Actions>
      </>
    )}
  </Styled.Wrapper>
);
